<script>
import { Page, CustomMenu } from '@/api'
import PageFormBase from '@/crudBases/form/PageFormBase'
import fields from '@/components/fields/'

export default {
  extends: PageFormBase,
  data() {
    return {
      livePreview: true,
      redirectRoute: { name: 'Pages List' }
    }
  },
  methods: {
    getGeneralFields() {
      return [
        new fields.Input({
          label: 'Tytuł',
          modelPath: [this, 'form', 'title'],
          required: true
        }),
        new fields.Switch({
          label: 'Ukryta',
          modelPath: [this, 'form', 'is_hidden']
        }),
        new fields.ForeignKey({
          service: CustomMenu,
          label: 'Menu',
          clearable: true,
          modelPath: [this, 'form', 'menu'],
          labelField: 'name'
        }),
        new fields.ColorPicker({
          label: 'Kolor tła',
          modelPath: [this, 'form', 'background_color']
        }),
        new fields.ColorPicker({
          label: 'Kolor tekstu',
          modelPath: [this, 'form', 'text_color']
        }),
        new fields.ColorPicker({
          label: 'Kolor akcentu',
          modelPath: [this, 'form', 'accent_color']
        }),
        new fields.Select({
          modelPath: [this, 'form', 'figure'],
          clearable: true,
          label: 'Figura w tle',
          options: [
            { value: 'ktr', label: 'KTR' },
            { value: 'see-and-say', label: 'SEE-AND-SAY' },
            { value: 'young-creatives', label: 'YOUNG-CREATIVES' },
            { value: 'innovation', label: 'INNOVATION' }
          ]
        })
      ]
    }
  },
  computed: {
    service() {
      return Page
    }
  }
}
</script>
